module.exports = __webpack_public_path__ + "img/only-window.f84bfe14.svg";